import { Volume2 } from "lucide-react";
import { API } from "@/lib/api";

export default function ChatMessage({ m, onPlay }) {
  const user = m.role === "user";
  const img = m.preview || (m.image_id && `${API}/uploads/${m.image_id}`);
  return (
    <div className={`flex ${user ? "justify-end" : "justify-start"}`}>
      <div data-testid={`chat-message-${m.role}`} className={`max-w-[80%] px-5 py-3 rounded-3xl whitespace-pre-wrap ${user ? "bg-[var(--text)] text-[var(--bg)] rounded-br-md" : "bg-[var(--surface-subtle)] rounded-bl-md"}`}>
        {img && <img data-testid="chat-message-photo" src={img} alt="photo envoyée" className="rounded-2xl mb-2 max-h-60 object-cover" />}
        {m.content || (
          <span className="flex gap-1 py-2">
            <span className="typing-dot" /><span className="typing-dot" style={{ animationDelay: ".2s" }} /><span className="typing-dot" style={{ animationDelay: ".4s" }} />
          </span>
        )}
        {!user && m.content && m.id !== "pending" && (
          <button data-testid="chat-message-play-button" onClick={() => onPlay(m.content)} className="flex items-center gap-1 text-xs text-[var(--text-muted)] hover:text-[var(--accent)] mt-2"><Volume2 size={14} /> Écouter</button>
        )}
      </div>
    </div>
  );
}
